const baseUrl = window.location.origin.replace(/(:\d*)$/g, "");

const settings = {
  socketPort: 8080,
  baseUrl,
};

export default settings;
